import { useCallback } from 'react';

export function useScrollToTop(ref) {
  return useCallback(() => {
    setTimeout(() => {
      ref.current?.scrollTo({ top: 0, behavior: 'smooth' });
    }, 500);
  }, [ref]);
}
